import { FLOW_TRACKER_INSIGHT_STATUS } from '@linearb/linjs-common';
import { TRACKING } from 'common/constants/constants';

export const ITERATION_SUMMARY_TITLE = 'AI Iteration Summary for';

export const SECTIONS = {
  ACCOMPLISHMENTS: 'accomplishments'
};

export const EXCLUDE_SECTIONS = ['tldr', 'finished'];

export const SECTIONS_TO_TRACKING_EVENTS_MAP = {
  [SECTIONS.ACCOMPLISHMENTS]:
    TRACKING.CLICK.ITERATION_SUMMARY.FEEDBACK_SECTIONS.ACCOMPLISHMENTS
};

export const buttonTooltipTitles = {
  [FLOW_TRACKER_INSIGHT_STATUS.INSIGHT_NOT_STARTED]: `AI Iteration Summary generation <br />is unavailable for this iteration.`,
  [FLOW_TRACKER_INSIGHT_STATUS.INSIGHT_FAILED]: `Oops! Something went wrong!<br /> Please contact support.`,
  [FLOW_TRACKER_INSIGHT_STATUS.INSIGHT_NOT_CREATED]: `AI Iteration Summary generation <br />is unavailable for this iteration.`,
  [FLOW_TRACKER_INSIGHT_STATUS.INSIGHT_STARTED]: `AI Iteration Summary is currently being <br />generated. Please come back soon!`
};

export const NO_ACVTIVITY_FOUND = `There was no activity recorded <br /> during this iteration.`;
